export default "__VITE_ASSET__BpTbfBJu__"